"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const zod_2 = require("zod");
const client_1 = require("@apollo/client");
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const GenericInput_1 = __importDefault(require("components/general/inputs/GenericInput"));
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const passwordRecoveryCopy_1 = require("copy/passwordRecoveryCopy");
const loginCopy_1 = require("copy/loginCopy");
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const queryDefinitions_1 = require("queryDefinitions");
const DEFAULT_FIELD_VALUES = {
    email: ''
};
const schema = zod_2.z.object({
    email: zod_2.z
        .string()
        .min(1, { message: 'Email is a required field' })
        .email({ message: 'Please enter a valid email' })
});
const linkProps = {
    preface: loginCopy_1.loginCopy.linkPreface,
    href: loginCopy_1.loginCopy.linkHref,
    prompt: loginCopy_1.loginCopy.linkPrompt
};
const successLinkProps = {
    href: passwordRecoveryCopy_1.passwordRecoveryCopy.linkHref,
    prompt: passwordRecoveryCopy_1.passwordRecoveryCopy.linkPrompt
};
const PasswordRecovery = () => {
    const { control, formState: { errors }, handleSubmit } = (0, react_hook_form_1.useForm)({
        defaultValues: DEFAULT_FIELD_VALUES,
        resolver: (0, zod_1.zodResolver)(schema)
    });
    const [recoverPassword, { data, loading, error }] = (0, client_1.useMutation)(queryDefinitions_1.REQUEST_PASSWORD_RESET);
    const onSubmit = handleSubmit(({ email }) => {
        recoverPassword({ variables: { input: { email } } });
    });
    const apiError = error;
    if (apiError) {
        apiError.title = passwordRecoveryCopy_1.passwordRecoveryCopy.errorTitle;
    }
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'login', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: apiError, contactLink: data ? undefined : linkProps, cta: data ? null : passwordRecoveryCopy_1.passwordRecoveryCopy.cta, header: passwordRecoveryCopy_1.passwordRecoveryCopy.header, inputs: data
                ? null
                : [
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, key: 'email', name: 'email', render: (_a) => {
                            var _b;
                            var _c = _a.field, { ref: _ref, value, onChange } = _c, rest = __rest(_c, ["ref", "value", "onChange"]);
                            return (react_1.default.createElement(GenericInput_1.default, Object.assign({}, rest, { error: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message, id: 'email', label: passwordRecoveryCopy_1.passwordRecoveryCopy.input1, onInputChange: (e) => onChange(e), value: value })));
                        } })
                ], loading: loading, onFormSubmit: onSubmit, successLink: data && successLinkProps, textPrompt: data ? passwordRecoveryCopy_1.passwordRecoveryCopy.confirmation : passwordRecoveryCopy_1.passwordRecoveryCopy.prompt }),
        react_1.default.createElement(HeroImage_1.default, { header: passwordRecoveryCopy_1.passwordRecoveryCopy.heroHeader, subheader: passwordRecoveryCopy_1.passwordRecoveryCopy.heroSubHeader })));
};
exports.default = PasswordRecovery;
